import { PublishOutlined } from '@mui/icons-material';
import { MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import type { Dispatch, SetStateAction } from 'react';
import { useRef } from 'react';

import type { FileManagerUploadingState } from '@/modules/files/components/file-manager/FileManagerUploadingBar';

import { useFileUploader } from '@/modules/files/hooks/useFileUploader';

import type { Segment } from '../FileManagerBreadcrumbsBarSegment';

interface Props {
  segment: Segment;
  setUploadingState: Dispatch<SetStateAction<FileManagerUploadingState>>;
  onClose: () => void;
  rootOwnerId: string;
}

export const UploadFileMenuItem = ({
  segment,
  setUploadingState,
  onClose,
  rootOwnerId,
}: Props) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const { handleUploadRequest } = useFileUploader({
    segment,
    setUploadingState,
    rootOwnerId,
  });

  return (
    <>
      <MenuItem
        onClick={() => {
          if (inputRef.current) {
            inputRef.current.click();
          }
          onClose();
        }}
        data-test="file-manager-folder-menu-file-upload-item"
      >
        <ListItemIcon>
          <PublishOutlined />
        </ListItemIcon>
        <ListItemText>Upload a file</ListItemText>
      </MenuItem>
      <input
        data-test="file-uploader-file-input"
        ref={inputRef}
        type="file"
        style={{ display: 'none' }}
        autoComplete="off"
        onChange={async (event) => {
          await handleUploadRequest(event);

          if (inputRef?.current?.value) {
            inputRef.current.value = '';
          }
        }}
        multiple={true}
      />
    </>
  );
};
